(() => {
  const initTabs = (root) => {
    root.querySelectorAll('[data-pdp-tabs]:not([data-bound])').forEach((tabs) => {
      tabs.dataset.bound = 'true';
      const buttons = [...tabs.querySelectorAll('.tab-btn')];
      const panels = [...tabs.querySelectorAll('.tab-panel')];
      if (!buttons.length) return;
      const activate = (button, focus = false) => {
        buttons.forEach((btn) => {
          const active = btn === button;
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.id === button.getAttribute('aria-controls');
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
        if (focus) button.focus();
      };
      buttons.forEach((button) => button.addEventListener('click', () => activate(button)));
      buttons.forEach((button, index) => button.addEventListener('keydown', (event) => {
        let targetIndex;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = buttons.length - 1;
        if (targetIndex === undefined) return;
        event.preventDefault();
        activate(buttons[targetIndex], true);
      }));
      activate(buttons[0]);
    });
  };

  const initStickyAtc = (root) => {
    root.querySelectorAll('[data-sticky-atc]:not([data-bound])').forEach((sticky) => {
      sticky.dataset.bound = 'true';
      const section = sticky.previousElementSibling;
      const trigger = section?.querySelector('.pdp-atc');
      const submitButton = sticky.querySelector('[data-sticky-atc-submit]');
      submitButton?.addEventListener('click', () => trigger?.click());
      if (!trigger) return;
      const toggle = () => {
        const rect = trigger.getBoundingClientRect();
        sticky.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
      };
      toggle();
      window.addEventListener('scroll', toggle, { passive: true });
      window.addEventListener('resize', toggle);
    });
  };

  const init = (root) => {
    initTabs(root);
    initStickyAtc(root);
  };

  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  /* Each tab_notes/tab_about/tab_ritual/tab_ingredients block's
     shopify_attributes sit directly on its .tab-btn, so selecting that
     block in the Theme Editor sidebar targets the button itself. Only the
     active tab's panel is visible at a time, so without this, selecting a
     block for a currently-hidden tab would show nothing to edit. */
  document.addEventListener('shopify:block:select', (event) => {
    const button = event.target.closest?.('.tab-btn');
    if (!button) return;
    button.click();
    button.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
